export const GET_UNITS = "GET_UNITS";
export const GET_PROSPECTS = "GET_PROSPECTS";
export const EMPTY_TENANTS = "EMPTY_TENANTS";
export const SET_UNIT_FILTERS = "SET_UNIT_FILTERS"